import { CHATS_SOCIAL_PLATFORMS } from 'constants/connect-plugin';
import { platformAccess } from './chats';

export const getFilteredPlatforms = (businessInfo = {}) => {
  if (!!businessInfo) {
    return CHATS_SOCIAL_PLATFORMS.filter(
      (platform) => platformAccess(businessInfo)[platform.keyName]
    );
  }

  return [];
};
